var _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5977,
    y1: 14.0981,
    x2: 13.5977,
    y2: 2.09814,
    stroke: "#D91F05"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.6646,
    y1: 6.84814,
    x2: 13.6646,
    y2: 1.65199,
    stroke: "#D91F05"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.6646,
    y1: 7.34814,
    x2: 13.6646,
    y2: 2.15199,
    stroke: "#D91F05"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12,
    y2: -0.5,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 4 2)",
    stroke: "#D91F05"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 6,
    y2: -0.5,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 1 9)",
    stroke: "#D91F05"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 6,
    y2: -0.5,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 7 9)",
    stroke: "#D91F05"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 0.5,
    r: 0.5,
    fill: "#D91F05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15.5,
    r: 0.5,
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSelect);
export default __webpack_public_path__ + "static/media/change_select.c23777e3ba73e06610f539db85c3ebc0.svg";
export { ForwardRef as ReactComponent };